import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';

// components
import {
    Button,
    FormGroup,
    Input,
    Modal,
    Row,
    Col,
} from "reactstrap";
import moment from "moment";

// services
import { getSessionCookie } from "../../../services/session.js";
import { formateDateApi } from "../../../helpers/formats.js";
import { InputPLACA } from "helpers/mask.js";
import { api_POST } from "services/api_service.js";
import { showMessage } from "services/message.js";
import { api_PUT } from "services/api_service.js";

export default function ModalViaComprovanteDescarregamento({ stateModal2ViaComprovante, comprovanteDescarregamento, ordemColeta, handleReturn, setshowLoading, ordemColetaDestinacaoId }) {
    const { register, handleSubmit, errors, setError, setValue, getValues, clearErrors } = useForm({ mode: "onBlur" });

    const [stateModal, setstateModal] = useState(stateModal2ViaComprovante);

    const session = getSessionCookie();

    const [inicio, setInicio] = useState();
    const [fim, setFim] = useState();
    
    useEffect(() => {
        setanexo(null);
        setstateModal(stateModal2ViaComprovante);
    }, [stateModal2ViaComprovante]);

    const [placa, setPlaca] = useState("");
    const handlePlaca = (event) => {
        setPlaca(event.target.value);
        clearErrors("placa");
    }

    const [anexo, setanexo] = useState(null);
    const handleAnexo = (event) => {
        if (event.target.files.length) {
            var reader = new FileReader();
            let _file = event.target.files[0];
            reader.readAsDataURL(_file);
            reader.onloadend = function () {
                var base64data = reader.result;
                setanexo({
                    base64: base64data.split(',')[1],
                    name: uuidv4() + '.' + _file.name.split('.').pop().toLowerCase()
                });
            }
        }
    }

    const handleAdd2ViaComprovanteDescarregamento = () => {
        let data = getValues();

        if (data.placa == '' ||
            data.dataEntrada == '' ||
            data.horaEntrada == '' ||
            data.dataSaida == '' ||
            data.horaSaida == '' ||
            data.pesoBruto == '' ||
            data.pesoLiquido == '' ||
            data.tara == ''
        ) {
            showMessage("Aviso", "Por favor todos os campos são obrigatórios.", "warning", null);
            return;
        }

        let _comprovante = {};
        if (comprovanteDescarregamento == null) {
            _comprovante.ordemColetaDestinacaoId = ordemColetaDestinacaoId;
            _comprovante.ordemColetaDestinacaoComprovanteId = 0;
        } else {
            _comprovante.ordemColetaDestinacaoId = ordemColetaDestinacaoId;
            _comprovante.ordemColetaDestinacaoComprovanteId = comprovanteDescarregamento.ordemColetaDestinacaoComprovanteId;
        }


        const json = {
            ordemColetaDestinacaoComprovanteId: _comprovante.ordemColetaDestinacaoComprovanteId,
            ordemColetaDestinacaoId: _comprovante.ordemColetaDestinacaoId,
            placaVeiculoBalanca: data.placa,
            dataHoraEntrada: data.dataEntrada + " " + data.horaEntrada + ":00",
            dataHoraSaida: data.dataSaida + " " + data.horaSaida + ":00",
            pesoBruto: data.pesoBruto,
            tara: data.tara,
            pesoLiquido: data.pesoLiquido,
            arquivo: anexo,
            usuarioEdicao_Id: session.usuarioId
        };
        
        if (!_comprovante.ordemColetaDestinacaoComprovanteId) {
            setshowLoading(true);
            api_POST('OrdemColeta/InsertViaComprovanteDescarregamento', json).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                    return;
                }
                else {
                    showMessage("Atenção", "Adicionado 2ª via de Comprovante de descarregamento.", 'success', () => {handleReturn(result.data)});
                }
            });
        } else {
            setshowLoading(true);
            api_PUT('OrdemColeta/UpdateViaComprovanteDescarregamento', json).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                    return;
                }
                else {
                    showMessage("Atenção", "Atualizado com sucesso a 2ª via de Comprovante de descarregamento!", 'success',  () => {handleReturn(result.data)});
                }
            });
        }
    }

    return (
        <>
            <Modal
                className="modal-dialog-centered"
                isOpen={stateModal}
                size="lg"
            >
                <div className="modal-header">
                    <h4 className="modal-title" id="modal-title-default">
                        Adicionar 2ª via de Comprovante de descarregamento
                    </h4>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => handleReturn(null)}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Placa
                                </label>
                                <InputPLACA
                                    name="placa"
                                    placeholder="Placa/Identificação"
                                    value={null}
                                    defaultValue={comprovanteDescarregamento ? comprovanteDescarregamento.placaVeiculoBalanca : ''}
                                    onChange={handlePlaca}
                                    inputRef={register({ required: true })}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Data - Entrada
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    innerRef={register({ required: true })}
                                    defaultValue={comprovanteDescarregamento && comprovanteDescarregamento.dataHoraEntrada ? formateDateApi(comprovanteDescarregamento.dataHoraEntrada) : ""}
                                    name="dataEntrada"
                                    placeholder="Data Entrada"
                                    type="date"
                                    max={formateDateApi(moment(new Date()))}
                                    onBlur={(e) => setInicio(formateDateApi(e.target.value))}
                                />
                                {errors.dataEntrada && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Hora - Entrada
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    innerRef={register({ required: true })}
                                    name="horaEntrada"
                                    defaultValue={comprovanteDescarregamento && comprovanteDescarregamento.dataHoraEntrada ? moment(comprovanteDescarregamento.dataHoraEntrada).format("HH:mm") : ""}
                                    placeholder="Hora entrada"
                                    type="time"
                                    onBlur={(e) => setFim(formateDateApi(e.target.value))}
                                />
                                {errors.horaEntrada && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Data - Saida
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    innerRef={register({ required: true })}
                                    defaultValue={comprovanteDescarregamento && comprovanteDescarregamento.dataHoraSaida ? formateDateApi(comprovanteDescarregamento.dataHoraSaida) : ""}
                                    name="dataSaida"
                                    placeholder="Data Saida"
                                    type="date"
                                    max={formateDateApi(moment(new Date()))}
                                    onBlur={(e) => setFim(formateDateApi(e.target.value))}
                                />
                                {errors.dataSaida && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Hora - Saida
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    innerRef={register({ required: true })}
                                    name="horaSaida"
                                    defaultValue={comprovanteDescarregamento && comprovanteDescarregamento.dataHoraSaida ? moment(comprovanteDescarregamento.dataHoraSaida).format("HH:mm") : ""}
                                    placeholder="Hora Saida"
                                    type="time"
                                />
                                {errors.horaSaida && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Peso Bruto Total
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    innerRef={register({ required: true })}
                                    name="pesoBruto"
                                    defaultValue={comprovanteDescarregamento ? comprovanteDescarregamento?.pesoBruto : ""}
                                    placeholder="Peso Bruto Total"
                                    type="number"
                                />
                                {errors.pesoBruto && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Tara
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    innerRef={register({ required: true })}
                                    name="tara"
                                    defaultValue={comprovanteDescarregamento ? comprovanteDescarregamento?.tara : ""}
                                    placeholder="Tara"
                                    type="number"
                                />
                                {errors.tara && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Peso Líquido
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    innerRef={register({ required: true })}
                                    defaultValue={comprovanteDescarregamento ? comprovanteDescarregamento?.pesoLiquido : ""}
                                    name="pesoLiquido"
                                    placeholder="Peso Bruto Total"
                                    type="number"
                                />
                                {errors.pesoLiquido && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        {comprovanteDescarregamento && comprovanteDescarregamento?.arquivo != null &&
                            <Col md="12" className="mb-2">
                                <a
                                    style={{ fontSize: "14px" }}
                                    href={session.pathVirtual + comprovanteDescarregamento.arquivo}
                                    target="_blank">
                                    Visualizar Anexo do Comprovante de Descarregamento
                                </a>
                            </Col>
                        }
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Importar Arquivo
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="arquivo"
                                    placeholder="Anexar Arquivo"
                                    type="file"
                                    onChange={handleAnexo}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
                <div className="modal-footer">
                    <Button color="secondary" type="button" onClick={() => handleReturn()}>
                        Cancelar
                    </Button>
                    <Button color="info" type="button" onClick={() => handleAdd2ViaComprovanteDescarregamento()}>
                        Adicionar
                    </Button>
                </div>
            </Modal>
        </>
    );
}
